import React, { useState, useEffect } from 'react';
import { API } from 'utils/Helper';
import { formatUserDate } from 'utils/timezoneHelper';

export default function CampaignPopupModal() {
  const [promo, setPromo] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchPopupCampaign = async () => {
      try {
        const res = await fetch(`${API}/api/campaigns?show_on=popup`);
        if (!res.ok) return;
        const data = await res.json();
        const campaigns = data?.campaigns || [];
        if (campaigns.length > 0) {
          const activeCampaign = campaigns[0]; // Highest priority active popup campaign
          
          // Check if user already dismissed this campaign in this session
          const dismissedKey = `campaign_popup_dismissed_${activeCampaign.id}`;
          if (sessionStorage.getItem(dismissedKey)) {
            return;
          }
          
          setPromo(activeCampaign);
          // Smooth delay before showing popup on page load
          setTimeout(() => {
            setIsOpen(true);
          }, 800);
        }
      } catch (err) {
        console.error('Error fetching campaign popup:', err);
      }
    };

    fetchPopupCampaign();
  }, []);

  const handleClose = () => {
    if (promo) {
      sessionStorage.setItem(`campaign_popup_dismissed_${promo.id}`, 'true');
    }
    setIsOpen(false);
  };

  if (!isOpen || !promo) return null;

  const display = promo.display_json || {};
  const bannerUrl = display.banner 
    ? (display.banner.startsWith('http') ? display.banner : `${API}${display.banner}`) 
    : '';

  return (
    <div 
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        backdropFilter: 'blur(5px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999999,
        padding: '16px'
      }}
      onClick={handleClose}
    >
      <div 
        style={{
          backgroundColor: '#1a2c38',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          borderRadius: '16px',
          width: '100%',
          maxWidth: '420px',
          padding: '12px 12px 14px 12px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.7)',
          color: '#fff',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Banner Container with Padding & Rounded Corners */}
        <div style={{
          width: '100%',
          aspectRatio: '16/9',
          maxHeight: '190px',
          overflow: 'hidden',
          backgroundColor: '#0f212e',
          borderRadius: '10px',
          position: 'relative'
        }}>
          <button
            onClick={handleClose}
            style={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              cursor: 'pointer',
              zIndex: 10,
              fontSize: '13px'
            }}
          >
            ✕
          </button>
          {bannerUrl ? (
            <img 
              src={bannerUrl} 
              alt={display.title || promo.name} 
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          ) : (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: '13px' }}>
              🎉 Special Promotion
            </div>
          )}
        </div>

        {/* Modal Body */}
        <div style={{ padding: '12px 4px 0 4px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
            <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 'bold', color: '#fff', letterSpacing: '-0.01em' }}>
              {display.title || promo.name}
            </h3>
            <span style={{ 
              backgroundColor: 'rgba(0, 231, 1, 0.15)', 
              color: '#00e701', 
              fontSize: '10px', 
              fontWeight: 'bold', 
              padding: '2px 8px', 
              borderRadius: '12px',
              border: '1px solid rgba(0, 231, 1, 0.3)',
              textTransform: 'uppercase'
            }}>
              Active
            </span>
          </div>

          {display.description && (
            <p style={{ 
              color: '#94a3b8', 
              fontSize: '13px', 
              lineHeight: '1.5', 
              margin: '0 0 12px 0',
              whiteSpace: 'pre-line'
            }}>
              {display.description}
            </p>
          )}

          {promo.end_date && (
            <div style={{ 
              backgroundColor: '#0f212e', 
              padding: '8px 12px', 
              borderRadius: '8px', 
              fontSize: '11px',
              color: '#94a3b8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <span>Promotion Period:</span>
              <span style={{ color: '#fff', fontWeight: '600' }}>
                Ends {formatUserDate(promo.end_date)}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
